// extracted by mini-css-extract-plugin
export default {"header":"TableSalaries_header__PJzik","scrolled":"TableSalaries_scrolled__xm1dL","progressSection":"TableSalaries_progressSection__TNLWc"};